import loadable from '@loadable/component';

export const GardeningetcSiteWrapper = loadable(
  () => import(/* webpackChunkName: "gardeningetc-site" */ './GardeningetcSiteWrapper'),
);
